module.exports = __webpack_public_path__ + "media/images/sample/ic_microsoft-3cc45525df7bbafb0b8bf7e15bd836ac.png";